import React from 'react'
import { FormattedMessage } from 'react-intl'

import { Icon } from '../../atoms'
import { ClientProposalVoteEnum } from '../../../lib/graphql'
import { cn } from '../../../shadcn/utils'

export const ClientProposalCardVote = ({
  upCount,
  downCount,
  onUpVote,
  onDownVote,
  selectedVote,
}: {
  upCount: number
  downCount: number
  onUpVote: () => void
  onDownVote: () => void
  selectedVote: ClientProposalVoteEnum | null
}) => {
  return (
    <div className='flex gap-2'>
      <div className='flex items-center'>
        <FormattedMessage
          id='ui.ClientProposalCardVote.vote'
          defaultMessage='Qu’en pensez-vous ?'
        />
      </div>
      <div className='flex select-none gap-3 rounded-full border border-grey-400 px-4 py-2'>
        <button
          className='group/thumb-up flex cursor-pointer items-center gap-1'
          onClick={onUpVote}
        >
          <Icon
            name={
              selectedVote === ClientProposalVoteEnum.LIKE
                ? 'thumb-up'
                : 'thumb-up-outline'
            }
            size={18}
            color='var(--green-500)'
            className={cn('transition-all group-hover/thumb-up:scale-110')}
          />
          {upCount}
        </button>
        <button
          className='group/thumb-down flex cursor-pointer items-center gap-1'
          onClick={onDownVote}
        >
          <Icon
            name={
              selectedVote === ClientProposalVoteEnum.DISLIKE
                ? 'thumb-down'
                : 'thumb-down-outline'
            }
            size={18}
            color='var(--red-500)'
            className='mt-1 transition-all group-hover/thumb-down:scale-110'
          />
          {downCount}
        </button>
      </div>
    </div>
  )
}
